import { ErpSystem } from "./erpSystem";
import PartnerIntegration from "./partnerIntegration";

export default class ErpIntegration extends PartnerIntegration {
    erpSystem: ErpSystem;
    isEnabled: boolean;

    enableContractWriteBack: boolean;
    enableContractExportThrottling: boolean;
    enableContractImport: boolean;
    contractPollingFrequencyInSeconds: number;
    enableContractPolling: boolean;

    commodityBalancePollingFrequencyInSeconds: number;
    enableCommodityBalancePolling: boolean;

    scaleTicketPollingFrequencyInSeconds: number;
    enableScaleTicketPolling: boolean;

    settlementPollingFrequencyInSeconds: number;
    enableSettlementPolling: boolean;

    accountPollingFrequencyInSeconds: number;
    enableAccountPolling: boolean;
    enableAccountAutoImport: boolean;

    enableHedgeOrderExport: boolean;

    priceBasisContractAsBasis: boolean;
    priceHtaContractAsHta: boolean;
    priceDelayedPriceContractAsDelayedPrice: boolean;

    isInventoryLocationEditingAllowed: boolean;
    erpConfiguration?: any;
}

export class ErpIntegrationThin {
    isEnabled: boolean;
    erpConfiguration?: any;
}